function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MigrationMainTemplate = require('./main.template');
var MigrationMain = /*#__PURE__*/function () {
  function MigrationMain(app, mod) {
    _classCallCheck(this, MigrationMain);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(MigrationMain, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (document.querySelector('.main')) {
                this.app.browser.replaceElementBySelector(MigrationMainTemplate(this.mod), '.main');
              } else {
                this.app.browser.addElementToDom(MigrationMainTemplate(this.mod));
              }
              this.attachEvents();
              this.renderDepositQrCode();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderDepositQrCode",
    value: function renderDepositQrCode() {
      var _this$mod$migration_i;
      var address = (_this$mod$migration_i = this.mod.migration_instructions) === null || _this$mod$migration_i === void 0 ? void 0 : _this$mod$migration_i.address;
      if (!address || !document.getElementById('migration-qrcode')) {
        return;
      }
      if (typeof this.app.browser.generateQRCode === 'function') {
        this.app.browser.generateQRCode(address, 'migration-qrcode');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var title = document.querySelector('#migration-title');
      var tickerSelect = document.querySelector('#wrapped-saito-ticker');
      tickerSelect === null || tickerSelect === void 0 || tickerSelect.addEventListener('change', function () {
        if (title) {
          title.textContent = tickerSelect.value === 'BEP-SAITO' ? 'Migrate BEP20 SAITO' : 'Migrate ERC20 SAITO';
        }
      });
      var depositAddress = document.querySelector('#migration-deposit-address');
      if (depositAddress) {
        depositAddress.onclick = function () {
          var _this$mod$migration_i2, _navigator;
          var address = ((_this$mod$migration_i2 = _this.mod.migration_instructions) === null || _this$mod$migration_i2 === void 0 ? void 0 : _this$mod$migration_i2.address) || '';
          if (!address || typeof ((_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.clipboard) === null || _navigator === void 0 ? void 0 : _navigator.writeText) !== 'function') {
            return;
          }
          navigator.clipboard.writeText(address);
          var icon = depositAddress.querySelector('i');
          if (!icon) {
            return;
          }
          icon.classList.toggle('fa-copy');
          icon.classList.toggle('fa-check');
          setTimeout(function () {
            icon.classList.toggle('fa-copy');
            icon.classList.toggle('fa-check');
          }, 800);
        };
      }
      var extend = document.querySelector('#migration-extend-reservation');
      if (extend) {
        extend.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
            var _this$mod$migration_i3, response, _t;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  event.preventDefault();
                  if (!(extend.dataset.busy === '1')) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  extend.dataset.busy = '1';
                  _context2.p = 2;
                  _context2.n = 3;
                  return _this.mod.requestMigrationExtend((_this$mod$migration_i3 = _this.mod.migration_instructions) === null || _this$mod$migration_i3 === void 0 ? void 0 : _this$mod$migration_i3.id);
                case 3:
                  response = _context2.v;
                  if (!(response !== null && response !== void 0 && response.error)) {
                    _context2.n = 4;
                    break;
                  }
                  throw new Error(response.error);
                case 4:
                  _this.mod.receiveMigrationInstructions(response);
                  _context2.n = 6;
                  break;
                case 5:
                  _context2.p = 5;
                  _t = _context2.v;
                  salert((_t === null || _t === void 0 ? void 0 : _t.message) || 'Unable to extend the reservation');
                  extend.dataset.busy = '0';
                case 6:
                  return _context2.a(2);
              }
            }, _callee2, null, [[2, 5]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      var button = document.querySelector('#migrate');
      if (!button) {
        return;
      }
      button.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _document$querySelect, _document$querySelect2;
        var publickey, ticker, backup, response, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              publickey = ((_document$querySelect = document.querySelector('#publickey')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.value) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.trim()) || '';
              ticker = ((_document$querySelect2 = document.querySelector('#wrapped-saito-ticker')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value) || 'ERC-SAITO';
              if (publickey) {
                _context3.n = 1;
                break;
              }
              salert('Enter the Saito address that should receive the tokens.');
              return _context3.a(2);
            case 1:
              if (!(publickey !== _this.mod.publicKey)) {
                _context3.n = 2;
                break;
              }
              salert('The publickey provided is not the publickey of this wallet. To avoid problems please request token withdrawal from the wallet which will receive the tokens');
              return _context3.a(2);
            case 2:
              if (!(ticker !== 'ERC-SAITO' && ticker !== 'BEP-SAITO')) {
                _context3.n = 3;
                break;
              }
              salert('Select ERC20 SAITO or BEP20 SAITO.');
              return _context3.a(2);
            case 3:
              button.disabled = true;
              _context3.p = 4;
              _context3.n = 5;
              return sconfirm('Migration will move assets into your wallet. Backup wallet?');
            case 5:
              backup = _context3.v;
              if (!backup) {
                _context3.n = 6;
                break;
              }
              _context3.n = 6;
              return _this.app.wallet.backupWallet();
            case 6:
              _context3.n = 7;
              return _this.mod.requestMigration({
                publickey: publickey,
                ticker: ticker
              });
            case 7:
              response = _context3.v;
              _this.mod.wrapped_saito_ticker = ticker;
              _this.mod.receiveMigrationInstructions(response);
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t2 = _context3.v;
              salert((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Migration request failed');
              button.disabled = false;
            case 9:
              return _context3.a(2);
          }
        }, _callee3, null, [[4, 8]]);
      }));
    }
  }]);
}();
module.exports = MigrationMain;